export default {
  id: 66,
  title: 'Target #66 - Batmicky',
  url: 'https://cssbattle.dev/play/66',
  colors: ['#191919', '#F2AD43'],
  solution:
    '<a a><a b><a c><a d><a e><a f><style>body{background:#191919}a{position:fixed}a[a],a[e],a[f]{background:#F2AD43}a[b],a[c],a[d]{background:#191919}a[c],a[d],a[f]{border-radius:50%}a[a]{top:100;left:80;width:240;height:80}a[b]{top:70;left:160;width:80;height:60;border-radius:10px}a[c]{top:100;left:25;width:100;height:100;box-shadow:250px 0 #191919}a[d]{top:160;left:40;width:200;height:200;box-shadow:120px 0 #191919}a[e]{top:110;left:190;width:20;height:20}a[f]{top:105;left:185;width:10;height:10;box-shadow:20px 0 #F2AD43}</style>',
}
